import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  rem,
} from "@styles/Utilities.styled";


export const StyledAddFileModalContent = styled.div`
  ${flexColumn}
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  .form {
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
    width: 100%;

    .form-field {
      margin-bottom: 1.5rem;
      width: 100%;
      max-width: 100%;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
  }

  .files-wrapper {
    margin-top: 0.5rem;
    font-size: ${rem(14)};
    width: 100%;
    max-width: 100%;

    .dropzone {
      ${flexCenter}
      height: ${rem(200)};
      padding: 2rem;
      background-color: var(--clr-gray-100);
      border: 2px dashed var(--clr-primary-700);
      border-radius: var(--border-radius-2);
      cursor: pointer;
      transition: all 0.2s ease;
      margin-bottom: 1rem;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;

      &.active {
        border: 2px dashed var(--clr-primary-400);
        background-color: ${alpha("var(--clr-primary-400)", 0.05)};
      }

      &.accept {
        background-color: var(--green-3);
        border-color: var(--green-8);
        animation: ${fileAcceptAnimation} 1s var(--ease-slow-start) forwards;
      }

      &.reject {
        background-color: ${alpha("var(--clr-rose)", 0.15)};
        border-color: ${alpha("var(--clr-rose)", 0.8)};
        animation: ${fileRejectAnimation} 0.1s ease-out 4 forwards;
      }

      .text-content {
        ${flexColumn}
        align-items: center;
        gap: 1.5rem;
        text-align: center;

        .p-wrapper {
          ${flexColumn}
          gap: 0.5rem;

          p:first-child {
            font-weight: 500;
            font-size: ${rem(16)};
            color: var(--clr-primary-700);
          }
          
          p:last-child {
            font-size: ${rem(14)};
            color: var(--clr-gray-400);
          }
        }

        .svg-wrapper {
          ${flexCenter}
          ${circle(rem(70))}
          background-color: ${alpha("var(--clr-primary-400)", 0.1)};
        }
      }
    }

    .uploaded-files {
      margin-bottom: 1rem;

      .uploaded-file {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }

        .file-info {
          ${flexSpBetween}
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);
          background-color: var(--clr-white);

          .file-details {
            ${flexColumn}
            gap: 0.25rem;
            flex: 1;
          }
        }
      }
    }

    .info-section {
      display: flex;
      align-items: flex-center;
      gap: 1rem;
      padding: 1rem;
      background-color: #f3f0ff;
      border-radius: var(--border-radius-2);
      border: none;

      .info-icon {
        ${flexCenter}
        ${circle(rem(24))}
        color: #8b5cf6;
        flex-shrink: 0;
        
        svg {
          font-size: ${rem(20)};
          font-weight: 600;
        }
      }

      .info-text {
        font-size: ${rem(14)};
        line-height: 1.5;
        color: #4c1d95;
        font-weight: 400;
        margin: 0;
      }
    }
  }

  /* Form field styling overrides */
  .mantine-Select-root {
    .mantine-Select-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  .mantine-TextInput-root {
    .mantine-TextInput-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  /* Submit button styling */
  .form-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 1.5rem;
    margin-top: 1rem;
  }
`;
